<div class="content">
  <div class="card">
    <div class="card-header header-elements-inline" [ngBusy]="busy">
      <h6 class="card-title">
        {{ isEditMode ? "Modifier un secteur d'activité" : "Ajouter un secteur d'activité" }}
      </h6>
      <div class="heading-elements">
        <button
          type="button"
          class="btn btn-info btn-xs"
          (click)="goBack()"
        >
          <i class="icon-arrow-left14 position-left"></i>Retour à la liste
        </button>
      </div>
    </div>

    <br />

    <div class="card-body">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">

        <div class="row">
          <!-- Nom -->
          <div class="col-md-6">
            <div class="form-group">
              <label>Nom <span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control"
                formControlName="nom"
                placeholder="Entrer le nom du secteur"
              />
              <span
                class="text-danger"
                *ngIf="form.get('nom')?.invalid && form.get('nom')?.touched"
              >
                Le nom est obligatoire
              </span>
            </div>
          </div>

          <!-- Description -->
          <div class="col-md-6">
            <div class="form-group">
              <label>Description</label>
              <input
                type="text"
                class="form-control"
                formControlName="description"
                placeholder="Entrer une description"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <!-- Actif -->
          <div class="col-md-6">
            <div class="form-group">
              <label>Statut</label>
              <div class="mt-1">
                <label class="mr-3">
                  <input
                    type="radio"
                    formControlName="actif"
                    [value]="true"
                    class="mr-1"
                  />
                  Actif
                </label>
                <label>
                  <input
                    type="radio"
                    formControlName="actif"
                    [value]="false"
                    class="mr-1"
                  />
                  Inactif
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-12">
            <button
              type="submit"
              class="btn btn-primary"
              [disabled]="form.invalid"
            >
              <i class="icon-floppy-disk position-left"></i>
              {{ isEditMode ? 'Modifier' : 'Ajouter' }}
            </button>
            <button
              type="button"
              class="btn btn-default ml-2"
              (click)="goBack()"
            >
              Annuler
            </button>
          </div>
        </div>

      </form>
    </div>
  </div>
</div>